import { spacingQuarck } from '@deskfy/unify-design-tokens/jsvariables'

/* @ngInject */
function MarketingCalendarController ($rootScope, $scope, $q, $timeout, ModalService, UdsModalService, TasksService, $state, $translate) {
  const DAYS_IN_WEEK = 7
  const EVENT_HEIGHT_MONTH = 24
  const EVENT_HEIGHT_WEEK = 68
  const EVENT_MARGIN_MONTH = 4
  const EVENT_MARGIN_WEEK = 8
  const FIRST_DAY_INDEX = 0
  const LAST_DAY_INDEX = 6
  const GRID_GAP = 8
  const SPACING = 8
  const MAX_EVENTS_MONTH = 2
  const MIN_EVENTS_HEIGHT_WEEK = 500

  $scope.gridGap = GRID_GAP
  $scope.spacing = SPACING
  $scope.hoveredDayIndex = null
  $scope.isEventHovered = false

  $scope.selectedDays = []
  $scope.isSelecting = false
  $scope.selectionStartIndex = null
  $scope.selectionEndIndex = null

  $scope.maxEventsHeight = 0
  $scope.days = []
  $scope.weekDays = []
  $scope.events = []
  $scope.mapEventsTimeout = null
  $scope.isSelectionActive = false

  const getNewTaskDialogController = () => $q.when(import('../../../workflow/dialogs/new-task/new-task-dialog.controller'))
  const getRequestFormDialogController = () => $q.when(import('../../../workflow/dialogs/request-form/request-form-dialog.controller'))

  const getRequestDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/request-details/request-details-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/subtask-details/subtask-details-dialog.controller'))
  const getCreateTaskDialogController = () => $q.when(import('../../../workflow/dialogs/create-task/create-task-dialog.controller'))
  const getCreateCampaignDialogController = () => $q.when(import('../../../campaigns/dialogs/create-campaign/create-campaign-dialog.controller'))

  const api = {
    getNewTaskDialogController,
    getRequestFormDialogController,
    getRequestDetailsDialogController,
    getSubtaskDetailsDialogController,
    getCreateTaskDialogController,
    getCreateCampaignDialogController,
    _renderCalendar,
    _getDaysInMonth,
    _getDaysInWeek,
    _getWeekDays,
    _addDaysInMonth,
    _addDaysAfterMonth,
    _addDaysBeforeMonth,
    _getStartOfWeek,
    _isCurrentDay,
    _createDayObject,
    _loadEvents,
    _mapEventsToDays,
    _mapEventsToDaysMonth,
    _mapEventsToDaysWeek,
    _calculateEventWidth,
    _getWeekText,
    _getWeekColor,
    _getDayText,
    _getDayColor,
    _getWeekEventsStructure,
    _organizeEventsByWeekAndColumn,
    _getEventTop,
    _createContinuationEvent,
    _isWeekendDay,
    _isSameDay,
    _normalizeDate,
    _isStartOfWeek,
    _isEndOfWeek,
    _getRowStartEvents,
    _isToReassignSlotIndex,
    _mountEventsItems,
    _getEventDates,
    _getEventDay,
    _startIdxForEvent,
    _mountEventsItemsCampaigns,
    _openCreateTask,
    _openNewCampaignDialog
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._renderCalendar()
  }

  const deregisterCalendarReload = $scope.$on('calendar.reload', api._renderCalendar)
  const deregisterViewModeWatcher = $scope.$watch('viewMode', api._renderCalendar)
  const deregisterDateWatcher = $scope.$watch('date', api._renderCalendar)
  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', api._openCreateTask)

  $scope.$on('$destroy', () => {
    deregisterCalendarReload()
    deregisterViewModeWatcher()
    deregisterDateWatcher()
    deregisterReopenCreateTaskDialog()
  })

  $scope.getWeekText = api._getWeekText
  $scope.getWeekColor = api._getWeekColor
  $scope.getDayText = api._getDayText
  $scope.getDayColor = api._getDayColor
  $scope.isWeekendDay = api._isWeekendDay

  $scope.openNewRequest = (isRequestWithUser = false, event) => {
    const taskDay = api._getEventDay(event)

    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          requestWithUser: isRequestWithUser,
          taskDay,
          reloadTasksCalendar: true
        }
      }).then((created) => {
        if (created) {
          $scope.$emit('marketingCalendar.reloadTasks')
        }
      })
    })
  }

  $scope.openNewTask = (event) => {
    const taskDay = api._getEventDay(event)

    api.getNewTaskDialogController().then(({ NewTaskDialogController }) => {
      ModalService.showModal({
        templateId: 'newTask.html',
        templateUrl: '/workflow/dialogs/new-task/new-task-dialog.html?$$REVISION$$',
        controller: NewTaskDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          taskDay,
          isCalendar: true
        }
      }).then((created) => {
        if (created) {
          $scope.$emit('marketingCalendar.reloadTasks')
        }
      })
    })
  }

  $scope.shouldShowMoreButton = (day) => {
    if (!day?.allEvents?.length || !day?.events?.length) return false

    const startDay = day.events[0]?.startDate
    const isMoreThanMaxEvents = (day.allEvents.filter(allEvent => !allEvent.isContinuation)).length > MAX_EVENTS_MONTH
    const isStartDay = startDay && api._isSameDay(day.value, startDay)

    return isMoreThanMaxEvents && isStartDay
  }

  $scope.isViewMonth = () => $scope.viewMode === 'month'

  $scope.isViewWeek = () => $scope.viewMode === 'week'

  $scope.getDropdownPosition = (day, isWeek) => api._isStartOfWeek(day, isWeek) ? 'right' : 'left'

  $scope.getDropdownDirection = (day) => {
    if (!$scope.days || !$scope.days.length) return 'down'

    const DAYS_IN_ROW = 7
    const dayIndex = $scope.days.findIndex(d => d.id === day.id)
    const totalRows = Math.ceil($scope.days.length / DAYS_IN_ROW)
    const row = Math.floor(dayIndex / DAYS_IN_ROW)
    return row === totalRows - 1 ? 'up' : 'down'
  }

  $scope.openTaskDialog = (event) => {
    if ($scope.originModule === 'campaigns') {
      $scope.openCampaignDetailDialog(event.id)
      return
    }

    if (event?.originType !== 'SUBTASK') {
      $scope.openTaskDetailDialog(event.id)
      return
    }

    $scope.openSubtaskModal(event)
  }

  $scope.openCampaignDetailDialog = (id) => {
    const url = $state.href('campaigns-edit', { id: id })
    window.open(url, '_blank')
  }

  $scope.openTaskDetailDialog = (id) => {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        },
        onClose: (data) => {
          if (data?.wasUpdated) {
            $scope.$emit('marketingCalendar.reloadTasks')
          }
        }
      })
      modal.open()
    })
  }

  $scope.openSubtaskModal = (subtask) => {
    TasksService.getTaskById(subtask.id).then((task) => {
      const subtask = task

      api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: SubtaskDetailsDialogController,
          modalName: 'subtaskDetailsDialog',
          data: {
            subtask
          }
        })
        modal.open()
      })
    })
  }

  $scope.setHoveredDay = (index) => {
    $scope.hoveredDayIndex = index % DAYS_IN_WEEK
  }

  $scope.clearHoveredDay = () => {
    $scope.hoveredDayIndex = null
  }

  $scope.setEventHovered = (isHovered) => {
    $scope.isEventHovered = isHovered
    if (!isHovered && !$scope.isSelecting) {
      $scope.isEventHovered = false
    }
  }

  $scope.openCreateTask = api._openCreateTask

  function _openNewCampaignDialog (startDateCalendar, endDateCalendar) {
    api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      const createCampaignDialog = UdsModalService.createModal({
        controller: CreateCampaignDialogController,
        modalName: 'createCampaignDialog',
        data: {
          startDateCalendar,
          endDateCalendar
        },
        onClose: () => {
          $scope.$emit('marketingCalendar.reloadCampaigns')
        }
      })

      createCampaignDialog.open()
    })
  }

  $scope.startDaySelection = (event, dayIndex) => {
    if ($scope.originModule === 'workflow') {
      return
    }

    if (event.target.closest('.marketing-calendar__day-events') || $scope.isEventHovered) {
      return
    }

    $scope.isSelecting = true
    $scope.isSelectionActive = true
    $scope.selectionStartIndex = dayIndex
    $scope.selectionEndIndex = dayIndex

    $scope.selectedDays = []

    const day = $scope.days[dayIndex]
    $scope.selectedDays.push(day)
  }

  $scope.updateDaySelection = (event, dayIndex) => {
    if (!$scope.isSelecting || $scope.isEventHovered) return

    $scope.selectionEndIndex = dayIndex

    updateSelectedDays()

    if ($scope.selectedDays.length > 0) {
      const newEvent = {
        title: $scope.originModule === 'campaigns' ? $translate.instant('campaignsModule.dialogs.newCampaign.headerTitle') : $translate.instant('newTask'),
        startDate: $scope.selectedDays[0].value,
        endDate: $scope.selectedDays[$scope.selectedDays.length - 1].value,
        day: $scope.selectedDays[0].value,
        value: $scope.selectedDays[0].value,
        status: 'NEW_EVENT'
      }

      const existingNewEventIndex = $scope.events.findIndex(event => event.status === 'NEW_EVENT')

      if (existingNewEventIndex !== -1) {
        $scope.events[existingNewEventIndex] = newEvent
      } else {
        $scope.events = [...$scope.events, newEvent]
      }

      if ($scope.mapEventsTimeout) {
        $timeout.cancel($scope.mapEventsTimeout)
      }

      $scope.mapEventsTimeout = $timeout(() => {
        if ($scope.isSelectionActive) {
          api._mapEventsToDays()
        }
      }, 100)
    }
  }

  $scope.endDaySelection = () => {
    $scope.isSelecting = false
    $scope.isSelectionActive = false

    if ($scope.mapEventsTimeout) {
      $timeout.cancel($scope.mapEventsTimeout)
      $scope.mapEventsTimeout = null
    }

    $scope.events = $scope.events.filter(event => event.status !== 'NEW_EVENT')

    if ($scope.selectedDays.length > 0) {
      const startDate = $scope.selectedDays[0].value
      const endDate = $scope.selectedDays[$scope.selectedDays.length - 1].value

      if ($scope.originModule === 'campaigns') {
        api._openNewCampaignDialog(startDate, endDate)
      } else {
        api._openCreateTask({
          day: null
        }, startDate, endDate)
      }
    }

    $scope.selectedDays = []
    $scope.selectionStartIndex = null
    $scope.selectionEndIndex = null
  }

  $scope.isSelectingDay = (day) => {
    if (!$scope.isSelecting) return false
    return $scope.selectedDays.some(selectedDay => selectedDay.id === day.id)
  }

  function updateSelectedDays () {
    if ($scope.selectionStartIndex === null || $scope.selectionEndIndex === null) return

    const startIndex = Math.min($scope.selectionStartIndex, $scope.selectionEndIndex)
    const endIndex = Math.max($scope.selectionStartIndex, $scope.selectionEndIndex)

    $scope.selectedDays = []

    for (let i = startIndex; i <= endIndex; i++) {
      if ($scope.days[i]) {
        $scope.selectedDays.push($scope.days[i])
      }
    }
  }

  $scope.getSelectedDays = () => {
    return $scope.selectedDays
  }

  $scope.hasSelectedDays = () => {
    return $scope.selectedDays.length > 0
  }

  function _renderCalendar () {
    const date = $scope.date
    $scope.weekDays = api._getWeekDays(date)
    $scope.days = $scope.viewMode === 'month'
      ? api._getDaysInMonth(date)
      : api._getDaysInWeek(date)
    api._loadEvents()
  }

  function _getDaysInMonth (date) {
    const days = []
    const year = date.getFullYear()
    const month = date.getMonth()
    const firstDayOfMonth = new Date(year, month, 1)
    const lastDayOfMonth = new Date(year, month + 1, 0)
    api._addDaysBeforeMonth(days, firstDayOfMonth)
    api._addDaysInMonth(days, firstDayOfMonth, lastDayOfMonth)
    api._addDaysAfterMonth(days, lastDayOfMonth)
    return days
  }

  function _addDaysBeforeMonth (days, firstDayOfMonth) {
    const firstDayWeekday = firstDayOfMonth.getDay()
    for (let i = firstDayWeekday - 1; i >= 0; i--) {
      const day = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth(), -i)
      days.push(api._createDayObject(day, false, false))
    }
  }

  function _addDaysInMonth (days, firstDayOfMonth, lastDayOfMonth) {
    for (let i = 1; i <= lastDayOfMonth.getDate(); i++) {
      const day = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth(), i)
      days.push(api._createDayObject(day, true, false))
    }
  }

  function _addDaysAfterMonth (days, lastDayOfMonth) {
    const lastDayWeekday = lastDayOfMonth.getDay()
    for (let i = 1; i < DAYS_IN_WEEK - lastDayWeekday; i++) {
      const day = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth() + 1, i)
      days.push(api._createDayObject(day, false, false))
    }
  }

  function _getDaysInWeek (date) {
    const days = []
    const startOfWeek = api._getStartOfWeek(date)
    for (let i = 0; i < DAYS_IN_WEEK; i++) {
      const day = new Date(startOfWeek)
      day.setDate(startOfWeek.getDate() + i)
      days.push(api._createDayObject(day, true, true))
    }
    return days
  }

  function _getWeekDays (date) {
    const weekDays = []
    const startOfWeek = api._getStartOfWeek(date)
    for (let i = 0; i < DAYS_IN_WEEK; i++) {
      const day = new Date(startOfWeek)
      day.setDate(startOfWeek.getDate() + i)
      weekDays.push({
        id: i,
        day,
        value: day.toLocaleDateString($scope.locale, { weekday: 'short' }),
        isCurrent: api._isCurrentDay(day)
      })
    }
    return weekDays
  }

  function _getStartOfWeek (date) {
    const startOfWeek = new Date(date)
    startOfWeek.setDate(date.getDate() - date.getDay())
    return startOfWeek
  }

  function _isCurrentDay (day) {
    const currentDate = new Date()
    return (
      currentDate.getFullYear() === day.getFullYear() &&
      currentDate.getMonth() === day.getMonth() &&
      currentDate.getDate() === day.getDate()
    )
  }

  function _createDayObject (day, isCurrentMonth, isWeekly) {
    const normalizedDay = api._normalizeDate(day)
    return {
      id: `${isCurrentMonth ? 'current' : 'other'}-${normalizedDay.getDate()}`,
      value: normalizedDay,
      isCurrentMonth,
      isWeekly,
      isCurrent: api._isCurrentDay(normalizedDay)
    }
  }

  function _loadEvents () {
    if ($scope.originModule === 'campaigns') {
      $scope.events = api._mountEventsItemsCampaigns($scope.campaigns)
    } else {
      $scope.events = api._mountEventsItems($scope.tasks)
    }

    api._mapEventsToDays()
  }

  function _mapEventsToDays () {
    if ($scope.viewMode === 'month') {
      api._mapEventsToDaysMonth()
    } else {
      api._mapEventsToDaysWeek()
    }
  }

  function _mapEventsToDaysMonth () {
    const eventHeight = EVENT_HEIGHT_MONTH
    const eventMargin = EVENT_MARGIN_MONTH
    const totalWeeks = Math.ceil($scope.days.length / DAYS_IN_WEEK)

    const eventsWithDates = $scope.events.map(ev => ({
      ...ev,
      _startDateObj: new Date(ev.startDate),
      _endDateObj: new Date(ev.endDate)
    }))

    for (let week = 0; week < totalWeeks; week++) {
      const weekStartIndex = week * DAYS_IN_WEEK
      const weekEndIndex = weekStartIndex + DAYS_IN_WEEK
      const weekDays = $scope.days.slice(weekStartIndex, weekEndIndex)
      const weekStart = api._normalizeDate(weekDays[0].value)
      const weekEnd = api._normalizeDate(weekDays[weekDays.length - 1].value)

      const stacks = Array(MAX_EVENTS_MONTH).fill(null).map(() => Array(DAYS_IN_WEEK).fill(null))

      const weekEvents = []
      for (let i = 0; i < eventsWithDates.length; i++) {
        const ev = eventsWithDates[i]
        for (let d = 0; d < weekDays.length; d++) {
          const day = weekDays[d]
          const dayDate = api._normalizeDate(day.value)
          if (dayDate >= ev._startDateObj && dayDate <= ev._endDateObj) {
            weekEvents.push(ev)
            break
          }
        }
      }

      const startEvents = []
      const continuingEvents = []
      for (let i = 0; i < weekEvents.length; i++) {
        const ev = weekEvents[i]
        if (ev._startDateObj >= weekStart && ev._startDateObj <= weekEnd) {
          startEvents.push(ev)
        } else if (ev._startDateObj < weekStart) {
          continuingEvents.push(ev)
        }
      }

      const orderedEvents = [...startEvents, ...continuingEvents]

      orderedEvents.forEach(event => {
        const evStartIdx = weekDays.findIndex(day => api._normalizeDate(day.value) >= event._startDateObj)
        const evEndIdx = weekDays.findIndex(day => api._normalizeDate(day.value) > event._endDateObj)
        const startIdx = evStartIdx !== -1 ? evStartIdx : 0
        const endIdx = evEndIdx !== -1 ? evEndIdx - 1 : (DAYS_IN_WEEK - 1)

        let stackIdx = 0
        for (; stackIdx < MAX_EVENTS_MONTH; stackIdx++) {
          let conflict = false
          for (let i = startIdx; i <= endIdx; i++) {
            if (stacks[stackIdx][i]) {
              conflict = true
              break
            }
          }
          if (!conflict) break
        }
        if (stackIdx < MAX_EVENTS_MONTH) {
          for (let i = startIdx; i <= endIdx; i++) {
            stacks[stackIdx][i] = event
          }
          event._stackIdx = stackIdx
        }
      })

      weekDays.forEach((day, dayIdx) => {
        day.allEvents = weekEvents.filter(ev =>
          ev._startDateObj <= api._normalizeDate(day.value) &&
          ev._endDateObj >= api._normalizeDate(day.value)
        )
        day.events = []

        for (let stackIdx = 0; stackIdx < MAX_EVENTS_MONTH; stackIdx++) {
          const event = stacks[stackIdx][dayIdx]
          if (
            event &&
            !day.events.some(e => e.id === event.id) &&
            (
              api._isSameDay(event.startDate, day.value) ||
              (dayIdx === 0 && api._normalizeDate(event.startDate) < api._normalizeDate(weekDays[0].value))
            )
          ) {
            const evEndIdx = weekDays.findIndex(d => api._normalizeDate(d.value) > event._endDateObj)
            const endIdx = evEndIdx !== -1 ? evEndIdx - 1 : (DAYS_IN_WEEK - 1)
            const daysSpanned = endIdx - dayIdx + 1
            const top = stackIdx * (eventHeight + eventMargin)
            day.events.push({
              ...event,
              isStartDay: true,
              isContinuation: !api._isSameDay(event.startDate, day.value) && api._normalizeDate(event.startDate) < api._normalizeDate(day.value),
              showTitle: !api._isSameDay(event.startDate, day.value) && api._normalizeDate(event.startDate) < api._normalizeDate(day.value),
              width: api._calculateEventWidth(daysSpanned, event),
              left: '0',
              top: `${top}px`
            })
          }
        }
      })
    }
  }

  function _mapEventsToDaysWeek () {
    const eventHeight = EVENT_HEIGHT_WEEK
    const eventMargin = EVENT_MARGIN_WEEK
    const weekDays = $scope.days
    const weekStart = api._normalizeDate(weekDays[0].value)
    const weekEnd = api._normalizeDate(weekDays[weekDays.length - 1].value)

    const weekEventsList = $scope.events.filter(ev => {
      const evStart = api._normalizeDate(ev.startDate)
      const evEnd = api._normalizeDate(ev.endDate)
      return evEnd >= weekStart && evStart <= weekEnd
    })

    const weekEventsListWithDates = weekEventsList.map(ev => ({
      ...ev,
      _startDateObj: new Date(ev.startDate),
      _endDateObj: new Date(ev.endDate)
    }))

    const MAX_EVENTS_WEEK = Math.max(weekEventsListWithDates.length, 10)
    const stacks = Array(MAX_EVENTS_WEEK).fill(null).map(() => Array(weekDays.length).fill(null))

    weekEventsListWithDates.sort((a, b) => {
      if (a._startDateObj - b._startDateObj !== 0) return a._startDateObj - b._startDateObj
      if (a._endDateObj - b._endDateObj !== 0) return a._endDateObj - b._endDateObj
      return a.id - b.id
    })

    weekEventsListWithDates.forEach(event => {
      const evStartIdx = weekDays.findIndex(day => api._normalizeDate(day.value) >= api._normalizeDate(event.startDate))
      const evEndIdx = weekDays.findIndex(day => api._normalizeDate(day.value) > api._normalizeDate(event.endDate))
      const startIdx = evStartIdx !== -1 ? evStartIdx : 0
      const endIdx = evEndIdx !== -1 ? evEndIdx - 1 : (weekDays.length - 1)

      let stackIdx = 0
      for (; stackIdx < MAX_EVENTS_WEEK; stackIdx++) {
        let conflict = false
        for (let i = startIdx; i <= endIdx; i++) {
          if (stacks[stackIdx][i]) {
            conflict = true
            break
          }
        }
        if (!conflict) break
      }
      if (stackIdx < MAX_EVENTS_WEEK) {
        for (let i = startIdx; i <= endIdx; i++) {
          stacks[stackIdx][i] = event
        }
        event._stackIdx = stackIdx
      }
    })

    weekDays.forEach((day, dayIdx) => {
      day.allEvents = weekEventsListWithDates.filter(ev =>
        api._normalizeDate(ev.startDate) <= api._normalizeDate(day.value) &&
        api._normalizeDate(ev.endDate) >= api._normalizeDate(day.value)
      )
      day.events = []

      for (let stackIdx = 0; stackIdx < MAX_EVENTS_WEEK; stackIdx++) {
        const event = stacks[stackIdx][dayIdx]
        if (
          event &&
          !day.events.some(e => e.id === event.id) &&
          (
            api._isSameDay(event.startDate, day.value) ||
            (api._startIdxForEvent(event, weekDays) === dayIdx && api._normalizeDate(event.startDate) < api._normalizeDate(weekDays[0].value))
          )
        ) {
          const evEndIdx = weekDays.findIndex(d => api._normalizeDate(d.value) > api._normalizeDate(event.endDate))
          const endIdx = evEndIdx !== -1 ? evEndIdx - 1 : (weekDays.length - 1)
          const daysSpanned = endIdx - dayIdx + 1
          const top = stackIdx * (eventHeight + eventMargin)
          day.events.push({
            ...event,
            isStartDay: true,
            isContinuation: !api._isSameDay(event.startDate, day.value) && api._normalizeDate(event.startDate) < api._normalizeDate(day.value),
            showTitle: !api._isSameDay(event.startDate, day.value) && api._normalizeDate(event.startDate) < api._normalizeDate(day.value),
            width: api._calculateEventWidth(daysSpanned, event),
            left: '0',
            top: `${top}px`
          })
        }
      }
    })

    const maxEventsInDay = Math.max(...weekDays.map(day => {
      const startEvents = day.events.length
      const extendingEvents = day.allEvents.filter(ev =>
        !day.events.some(startEv => startEv.id === ev.id)
      ).length

      return startEvents + extendingEvents
    }))

    const maxEventsHeight = maxEventsInDay * eventHeight + (maxEventsInDay - 1) * (eventMargin + 2)

    if (maxEventsHeight > MIN_EVENTS_HEIGHT_WEEK) {
      $scope.maxEventsHeight = maxEventsHeight
    }
  }

  function _getWeekEventsStructure (days) {
    const weekEvents = {}
    days.forEach((day, index) => {
      const week = Math.floor(index / DAYS_IN_WEEK)
      const column = index % DAYS_IN_WEEK
      if (!weekEvents[week]) weekEvents[week] = {}
      if (!weekEvents[week][column]) weekEvents[week][column] = []
    })
    return weekEvents
  }

  function _organizeEventsByWeekAndColumn (events, days, weekEvents) {
    events.forEach(event => {
      const startDayIndex = days.findIndex(
        d => d.value.toDateString() === event.startDate.toDateString()
      )
      if (startDayIndex !== -1) {
        const week = Math.floor(startDayIndex / DAYS_IN_WEEK)
        const column = startDayIndex % DAYS_IN_WEEK
        weekEvents[week][column].push(event)
      }
    })
  }

  function _getEventTop (event, weekStartEvents, eventHeight, eventMargin) {
    const verticalIndex = weekStartEvents.findIndex(e => e.id === event.id)
    return Math.max(0, verticalIndex * (eventHeight + eventMargin))
  }

  function _createContinuationEvent () {}

  function _calculateEventWidth (days, event) {
    const totalGapWidth = ((days - 1) * $scope.gridGap)
    const compensationGap = event.startDate.getDate() !== event.endDate.getDate() ? spacingQuarck : '0px'
    const marginRight = days >= 2 ? ((3 * days) + $scope.gridGap) : 16
    return `calc(${days * 100}% + ${totalGapWidth - marginRight}px - ${compensationGap})`
  }

  function _isWeekendDay (day) {
    if (!day.isCurrentMonth) return false
    const currentDay = day.value.getDay()
    return currentDay === FIRST_DAY_INDEX || currentDay === LAST_DAY_INDEX
  }

  function _isSameDay (a, b) {
    const dateA = api._normalizeDate(a)
    const dateB = api._normalizeDate(b)
    return (
      dateA.getFullYear() === dateB.getFullYear() &&
      dateA.getMonth() === dateB.getMonth() &&
      dateA.getDate() === dateB.getDate()
    )
  }

  function _normalizeDate (date) {
    const d = (date instanceof Date) ? new Date(+date) : new Date(date)
    d.setHours(0, 0, 0, 0)
    return d
  }

  function _getWeekText (week) {
    const weekName = week.value
    const weekDate = week.day.getDate()
    if ($scope.viewMode === 'week') return `${weekName} ${weekDate}`
    return weekName
  }

  function _getWeekColor (week) {
    if ($scope.viewMode === 'week' && week.isCurrent) return 'neutralColorHighPure'
    return 'neutralColorLowPure'
  }

  function _getDayText (day) {
    const dayNumber = day.value.getDate()
    if (day.value.getDate() === 1) {
      return day.value.toLocaleDateString($scope.locale, { month: 'short', day: 'numeric' })
    }
    return dayNumber
  }

  function _getDayColor (day) {
    if ($scope.viewMode === 'month' && day.isCurrent) return 'neutralColorHighPure'
    if (day.isCurrentMonth) return 'neutralColorLowPure'
    return 'neutralColorLowMediumLightest'
  }

  function _isStartOfWeek (day, isWeek) {
    if (isWeek) return day.day.getDay() === FIRST_DAY_INDEX
    return day.value.getDay() === FIRST_DAY_INDEX
  }

  function _isEndOfWeek (day, isWeek) {
    if (isWeek) return day.day.getDay() === LAST_DAY_INDEX
    return day.value.getDay() === LAST_DAY_INDEX
  }

  function _getRowStartEvents (days, dayIndex) {
    const DAYS_IN_ROW = 7
    const rowStart = Math.floor(dayIndex / DAYS_IN_ROW) * DAYS_IN_ROW
    const rowEnd = rowStart + DAYS_IN_ROW
    let rowEvents = []
    for (let i = rowStart; i < rowEnd; i++) {
      if (days[i] && days[i].events) {
        const startDayEvents = days[i].events.filter(ev => ev.isStartDay)
        rowEvents = rowEvents.concat(startDayEvents)
      }
    }

    const seen = new Set()
    const rowEventsWithDates = []

    for (let i = 0; i < rowEvents.length; i++) {
      const ev = rowEvents[i]
      if (!seen.has(ev.id)) {
        seen.add(ev.id)
        rowEventsWithDates.push({
          ...ev,
          _startDateObj: new Date(ev.startDate),
          _endDateObj: new Date(ev.endDate)
        })
      }
    }
    rowEventsWithDates.sort((a, b) => {
      const aIsSingle = a._startDateObj.toDateString() === a._endDateObj.toDateString()
      const bIsSingle = b._startDateObj.toDateString() === b._endDateObj.toDateString()
      if (aIsSingle !== bIsSingle) return aIsSingle ? -1 : 1
      if (a._startDateObj - b._startDateObj !== 0) return a._startDateObj - b._startDateObj
      return a.id - b.id
    })
    return rowEventsWithDates
  }

  function _isToReassignSlotIndex (dayEvents, continuations) {
    const isContinuationAndSingle =
      dayEvents.length === 2 &&
      dayEvents[0].isContinuation &&
      !dayEvents[1].isContinuation &&
      dayEvents[0].id.toString().split('-')[0] === dayEvents[1].id.toString()

    const isContinuationAndSingleDay =
      dayEvents.length === 2 &&
      (
        (dayEvents[0].isContinuation && api._isSameDay(dayEvents[1].startDate, dayEvents[1].endDate)) ||
        (dayEvents[1].isContinuation && api._isSameDay(dayEvents[0].startDate, dayEvents[0].endDate))
      )

    const anySlotHigh = dayEvents.some(ev => ev._slotIndex > 1)

    const isSingleContinuation =
      continuations.length === 1 && dayEvents.length === 1

    const isTwoRangeEvents =
      dayEvents.length === 2 &&
      !dayEvents[0].isContinuation &&
      !dayEvents[1].isContinuation &&
      !api._isSameDay(dayEvents[0].startDate, dayEvents[0].endDate) &&
      !api._isSameDay(dayEvents[1].startDate, dayEvents[1].endDate)

    const isSingleDayEvent =
      dayEvents.length === 1 &&
      api._isSameDay(dayEvents[0].startDate, dayEvents[0].endDate)

    const isTwoSingleDayEvents =
      dayEvents.length === 2 &&
      api._isSameDay(dayEvents[0].startDate, dayEvents[0].endDate) &&
      api._isSameDay(dayEvents[1].startDate, dayEvents[1].endDate)

    if (isContinuationAndSingle) {
      dayEvents = [dayEvents[0]]
    }

    return (
      (isContinuationAndSingleDay && anySlotHigh) ||
      isSingleContinuation ||
      isTwoRangeEvents ||
      isSingleDayEvent ||
      isTwoSingleDayEvents
    )
  }

  function _mountEventsItems (tasks) {
    const events = tasks.items.map(task => {
      const { startDate, endDate } = api._getEventDates(task)

      return {
        ...task,
        startDate,
        endDate,
        user: {
          id: task.authorId,
          name: task.author.name
        },
        status: task.status
      }
    })

    return events
  }

  function _mountEventsItemsCampaigns (campaigns) {
    const events = campaigns.map(campaign => {
      const { startDate, endDate } = api._getEventDates(campaign)

      return {
        ...campaign,
        startDate,
        endDate,
        status: campaign.status
      }
    })

    return events
  }

  function _getEventDates (task) {
    const startDate = ($scope.viewMode === 'day' || $scope.originModule === 'campaigns' || $scope.deliveryView === 'startDate') ? task.startDate : task.deliveryDate
    const endDate = task.deliveryDate

    return {
      startDate: api._normalizeDate(startDate),
      endDate: api._normalizeDate(endDate)
    }
  }

  function _getEventDay (event) {
    if ($scope.viewMode === 'week') {
      return event.day.toISOString()
    }

    return event.value.toISOString()
  }

  function _startIdxForEvent (event, weekDays) {
    const evStartIdx = weekDays.findIndex(day => api._normalizeDate(day.value) >= api._normalizeDate(event.startDate))
    return evStartIdx !== -1 ? evStartIdx : 0
  }

  function _openCreateTask (weekDay, startDate, endDate) {
    const day = weekDay.day || weekDay.value

    api.getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        data: {
          startDate: day ? day.toISOString() : startDate,
          endDate: endDate,
          isCalendar: true
        },
        onClose: (created) => {
          if (created || (startDate && endDate)) {
            $scope.$emit('marketingCalendar.reloadTasks')
          }
        }
      })

      modal.open()
    })
  }
}

export { MarketingCalendarController }
